export function formatEducLevel(str = "") {
  return str
    .split(",")
    .map((s) => s.trim())
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join(", ");
}
